/* eslint-disable no-restricted-imports */
import React from 'react';
import { Link } from 'react-router-dom';
import { MainContainer, ScrollableContainer } from '../../routing/users/CollectionDetails/styles';
import { useBackButton } from '../../utils/useBackButton';
import { useTranslation } from '../../utils/useTranslation';
import { DashboardPage } from '../dashboard/DashboardPage';
import { IconArrowLeft } from '../icon/IconArrowLeft';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import { HEADER_BUTTON_WIDTH } from './constants';
import { useHeaderSizes } from './hooks/useHeaderSizes';

export const CollectionNotFound = () => {
    const t = useTranslation();
    const { headerHeight, headerButtonTop } = useHeaderSizes();
    const onNavigateBack = useBackButton();

    return (
        <DashboardPage height={{ xs: '100dvh', sm: '100vh' }} gridFeed hideHeader>
            <MainContainer>
                <ScrollableContainer>
                    <Flex
                        px={1}
                        py={headerButtonTop}
                        width="100%"
                        height={headerHeight}
                        direction="row"
                    >
                        <Box width={HEADER_BUTTON_WIDTH} p={1}>
                            <IconArrowLeft
                                color="var(--color-primary)"
                                size={24}
                                onClick={onNavigateBack}
                            />
                        </Box>
                    </Flex>
                    <Flex p={4} height={`calc(100% - ${headerHeight}px)`} justifyContent="center">
                        <Typography variant="title1" weight="heavy" pb={1.5}>
                            {t('Не удалось загрузить коллекцию')}
                        </Typography>
                        <Typography pb={3}>
                            {t('Возможно, автор ее удалил или случилась ошибка')}
                        </Typography>
                        <Flex spacing={1}>
                            <Button
                                size="m"
                                onClick={() => window.location.reload()}
                                color="secondary"
                            >
                                {t('Попробовать ещё раз')}
                            </Button>
                            <Button size="m" as={Link} to="/">
                                {t('Найти интересное в ленте')}
                            </Button>
                        </Flex>
                    </Flex>
                </ScrollableContainer>
            </MainContainer>
        </DashboardPage>
    );
};
